import FetchUtils from 'src/utils/fetch_utils';
import { syncQuestionSubquestions } from '../subquestions';
import { updateUnansweredCount } from '../unanswered_count';
import { setRoommatesValue } from '../roommates_utils';

/**
 * Handles saving a question answer: PUT request, response handling, and error recovery.
 */
export class QuestionAnswerSaveHandler {
  constructor({ saveUrl, questionId }) {
    this.saveUrl = saveUrl;
    this.questionId = questionId;
  }

  /**
   * @param {Object} ctx - { getValueForRequest, getStoredValue, getCurrentDisplayValue, updateDisplay, stopEditing, isRoommates, editorElement, getDisplayText, questionBlock, questionWrap }
   */
  save(ctx) {
    const valueForRequest = ctx.getValueForRequest();
    const oldValue = ctx.getStoredValue();
    const currentValue = ctx.getCurrentDisplayValue();

    if (ctx.isRoommates && valueForRequest === oldValue) {
      ctx.stopEditing();
      return;
    }
    if (!ctx.isRoommates && currentValue === oldValue) {
      return;
    }

    if (ctx.isRoommates) {
      ctx.questionWrap.dataset.value = valueForRequest;
      ctx.updateDisplay(currentValue);
      ctx.display.classList.toggle('showing-view-popup__question-answer--empty', !currentValue);
    } else {
      ctx.stopEditing();
      ctx.updateDisplay(currentValue);
    }

    const body = new URLSearchParams();
    body.set('question_id', this.questionId);
    body.set('text', valueForRequest);

    fetch(this.saveUrl, {
      method: 'PUT',
      headers: {
        'x-csrf-token': FetchUtils.CSRFToken(),
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        accept: 'application/json'
      },
      body: body.toString()
    })
      .then(FetchUtils.checkResponseStatus)
      .then((resp) => resp.json())
      .then((response) => {
        if (!response.success) {
          throw { smErrText: (response.errors || ['Unable to save answer.'])[0] };
        }
        const responseDisplay = response.text ?? currentValue;
        ctx.updateDisplay(responseDisplay);
        if (ctx.isRoommates) {
          ctx.questionWrap.dataset.value = valueForRequest;
          ctx.stopEditing();
        } else {
          ctx.questionWrap.dataset.value = responseDisplay;
        }
        syncQuestionSubquestions(
          ctx.questionBlock,
          this.questionId,
          ctx.isRoommates ? valueForRequest : responseDisplay
        );
        updateUnansweredCount(ctx.questionWrap.closest('.js-showing-view-screening'));
      })
      .catch((err) => {
        if (ctx.isRoommates) {
          try {
            const restored = JSON.parse(oldValue);
            setRoommatesValue(ctx.editorElement, restored);
            ctx.display.textContent = ctx.getDisplayText(ctx.getRoommatesDisplayValue());
          } catch {
            // Keep the current editor value if the previous roommate payload is malformed.
          }
        } else {
          ctx.updateDisplay(oldValue);
        }
        FetchUtils.handleResponseError(err);
      });
  }
}
